import * as getters from './getters';

import actions from './actions';
import mutations from './mutations';

const state = () => ({
  companySymbols: { data: null, loading: false, error: null },
  headlines: { data: null, loading: false, error: null },
  tickersToCompare: { data: null, loading: false, error: null },
  nextHeadlines: { data: null, loading: false, error: null },
  primaryTickerFundamentals: {
    data: null,
    loading: false,
    error: null,
    hasPrimaryTickerFundamentals: true,
  },
  tickerFundamentals: { data: null, loading: false, error: null },
  currentlyActiveTicker: {},
  currentlyActiveTickerIndex: 0,
  companyPortfolios: { data: null, loading: false, error: null },
  nextCompanyPortfolios: { data: null, loading: false, error: null },
  companyProfileComments: { data: null, loading: false, error: null },
  repliesLoading: false,
  nextCommentsLoading: false,
  deleteCompanyComment: { data: null, loading: false, error: null },
  additionalSymbolsLoading: false,
  // Used to prevent trying to load additional symbols if there were already loaded
  additionalSymbolsLoaded: false,
  lastFetchedCompanyProfileId: null,
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
